import { Placement } from 'tippy.js';

export const TIPPY_PRESETS = {
  popover: {
    className: 'legacy-eds-popover',
    tippyProps: {
      arrow: false,
      trigger: 'click',
    },
  },
  'popover-hover': {
    className: 'legacy-eds-popover',
    tippyProps: {
      arrow: false,
      trigger: 'mouseenter focusin',
    },
  },
  dropdown: {
    className: 'eds-dropdown',
    tippyProps: {
      arrow: false,
      trigger: 'click',
      placement: 'bottom-start' as Placement,
    },
    popperConfig: {
      flip: {
        name: 'flip',
        enabled: true,
        options: {
          fallbackPlacements: [
            'bottom-start',
            'bottom-end',
            'bottom',
            'top-start',
            'top-end',
            'top',
            'right-start',
            'right-end',
            'right',
            'left-start',
            'left-end',
            'left',
          ],
        },
      },
    },
  },
  tooltip: {
    className: 'eds-tooltip',
    tippyProps: {
      arrow: true,
      trigger: 'mouseenter focusin',
    },
  },
  'tooltip.inverse': {
    className: 'eds-tooltip-inverse',
    tippyProps: {
      arrow: true,
      trigger: 'mouseenter focusin',
    },
  },
};
